export default __webpack_public_path__ + "static/media/963hz-spiritual-oneness.05a86c2c.ogg";